import React from "react";
import appContext from "../../../appContext";
import TrashImage from "../../../assets/emptystats/trash.svg";

import { textConstants } from "./utils";
import { useMediaQuery } from "@mui/material";
import { TakeToTemplatesButton } from "../Buttons";
import { sidebarValueConstants } from "../../../pages/Workspace/sidebarutils";

import {
  RootContainer,
  ImageContainer,
  PreviewImage,
  TextContainer,
  SubHeaderText,
  HeaderText,
  ButtonContainer,
} from "./Styled";

export default function TrashEmpty() {
  const { setSelectedMode } = React.useContext(appContext);
  const isLessThan1024 = useMediaQuery("(max-width:1025px)");

  const handleOnTemplateClick = () => {
    setSelectedMode(sidebarValueConstants.published);
  };

  return (
    <RootContainer>
      <ImageContainer>
        <PreviewImage isLessThan1024={isLessThan1024} src={TrashImage} />
      </ImageContainer>
      <TextContainer>
        <SubHeaderText>{textConstants.nothingToShow}</SubHeaderText>
        <HeaderText>{textConstants.trashEmpty}</HeaderText>
      </TextContainer>
      <ButtonContainer>
        <TakeToTemplatesButton onClick={handleOnTemplateClick} />
      </ButtonContainer>
    </RootContainer>
  );
}
